import React from "react";
import styled, { css } from "styled-components";
import { Row, Col, Typography, Button } from "antd";
import JobInfo from "components/job/index/jobInfo";
import JobCover from "components/job/index/jobCover";
import JobContent from "components/job/index/jobContent";

const { Text } = Typography;

const JobInformationRow = (props) => {
  const { data, status } = props;

  // Component State
  const [toggleMore, setToggleMore] = React.useState(false);

  return (
    <CollapsibleRow gutter={8} $fullHeight={toggleMore}>
      <Col span={12} style={{ height: "inherit", paddingLeft: "2px" }}>
        <JobInfo data={data} status={status} />
      </Col>

      <Col span={6} style={{ height: "inherit" }}>
        <JobCover data={data?.cover} status={status} />
      </Col>

      <Col span={6} style={{ height: "inherit", paddingRight: "2px" }}>
        <JobContent data={data?.content} status={status} />
      </Col>

      <Col
        span={24}
        style={{ height: "inherit", paddingRight: "2px", paddingLeft: "2px" }}
      >
        <CollapsibleButtonContainer $fullHeight={toggleMore}>
          <StyledButton type="link" onClick={() => setToggleMore(!toggleMore)}>
            {toggleMore ? <p>View Less</p> : <p>View More</p>}
          </StyledButton>
        </CollapsibleButtonContainer>
      </Col>
    </CollapsibleRow>
  );
};

const CollapsibleRow = styled(Row)`
  height: 165px;
  margin-top: ${(props) => props.theme.spacing[2]};
  margin-bottom: ${(props) => props.theme.spacing[2]};

  ${(props) =>
    props.$fullHeight &&
    css`
      height: inherit;
      transition: height 3s;
      margin-bottom: 0;
    `};
`;

const CollapsibleButtonContainer = styled.div`
  color: black;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-top: -45px;

  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      margin-top: ${(props) => props.theme.spacing[2]};
      background-image: none;
      height: auto;
      margin-bottom: ${(props) => props.theme.spacing[2]};
    `};
`;

const StyledButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.green[100]};
  border: 1px solid ${(props) => props.theme.colors.green[600]};
  color: ${(props) => props.theme.colors.green[800]};
  border-radius: 9999px;
  height: auto;
  padding: 0;

  :focus {
    background-color: ${(props) => props.theme.colors.green[100]};
    border: 1px solid ${(props) => props.theme.colors.green[600]};
    color: ${(props) => props.theme.colors.green[800]};
    border-radius: 9999px;
    height: auto;
    padding: 0;
  }

  :hover {
    color: ${(props) => props.theme.colors.green[800]};
    background-color: ${(props) => props.theme.colors.green[200]};
    border: 1px solid ${(props) => props.theme.colors.green[600]};
    color: ${(props) => props.theme.colors.green[800]};
    border-radius: 9999px;
    height: auto;
    padding: 0;
  }

  p {
    margin: 0;
    padding-left: ${(props) => props.theme.spacing[2]};
    padding-right: ${(props) => props.theme.spacing[2]};
    font-size: ${(props) => props.theme.fontSize["xs"]};
  }
`;

export const StyledList = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[2]};
  border-bottom: 1px solid ${(props) => props.theme.colors.grey[300]};

  ${(props) =>
    props.$last &&
    css`
      border-bottom: none;
    `};
`;

export const StyledDetail = styled.div`
  display: flex;
  flex-direction: column;

  .title {
    font-size: ${(props) => props.theme.fontSize["xs"]};
    font-weight: 400;
    color: ${(props) => props.theme.colors.grey[600]};
  }

  .value {
    font-size: ${(props) => props.theme.fontSize["base"]};
    font-weight: 500;
    color: ${(props) => props.theme.colors.grey[700]};
  }

  ${(props) =>
    props.$mt2 &&
    css`
      margin-top: ${(props) => props.theme.spacing[2]};
    `};
`;

export const StyledChildRow = styled(Row)`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};

  button {
  }

  ${(props) =>
    props.$newJob &&
    css`
      margin-top: ${(props) => props.theme.spacing[2]};
      padding: ${(props) => props.theme.spacing[4]};
    `};
`;

export const StyledTitle = styled(Text)`
  font-size: ${(props) => props.theme.fontSize["sm"]};
  font-weight: 600;
  color: ${(props) => props.theme.colors.grey[600]};
`;

export const TitleContainer = styled.div`
  padding: ${(props) => props.theme.spacing[2]};
  padding-bottom: 0;

  ${(props) =>
    props.$noYPadding &&
    css`
      padding-top: 0;
      padding-bottom: 0;
    `};
`;

export const EmptyContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledBox = styled.div`
  height: 100%;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export default JobInformationRow;
